export const recordAlgoliaImpression = ({
  objectID,
  queryID,
  event,
  userID,
  referrer
}) => {
  fetch('/api/insights/event', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      referrer: referrer
    },
    body: JSON.stringify({
      eventType: 'impression',
      objectID,
      queryID,
      event,
      userID
    })
  })
}

export const recordAlgoliaClick = ({
  objectID,
  queryID,
  event,
  userID,
  position,
  referrer
}) => {
  fetch('/api/insights/event', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      referrer: referrer
    },
    body: JSON.stringify({
      eventType: 'click',
      objectID,
      queryID,
      event,
      userID,
      position
    })
  })
}

export const recordAlgoliaConversion = ({
  objectID,
  queryID,
  event,
  userID
}) => {
  fetch('/api/insights/event', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      eventType: 'conversion',
      objectID,
      queryID,
      event,
      userID
    })
  })
}
